import React, { useEffect, useState, Fragment,useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import GateCard from 'components/sales/cardSection/gateCard/gateCard';
import { MrfStatus } from 'components/installation/mrfStatus/mrfStatus';
import ModalPop from 'components/sales/modal/modal';
import FormSectionNew from 'components/sales/formSection/formSectionNew';
import { Button } from 'react-bootstrap';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import { ConsolidateReport } from 'components/installation/consolidateReport/consolidateReport';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import useLatLng from 'hooks/uselatlng/uselatlng';
import { Link } from "react-router-dom";
import './siteInspection.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CardSectionNew from 'components/sales/cardSection/cardSectionNew';
import FormSection from 'components/sales/formSection/formSectionNew';
import TableSection from 'components/sales/tableSection/tableSection';
import ProductInventory from "components/sales/formSection/productInventory/productInventorySolution";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";


const SiteInspectionMaterial = ({
  getSiteInspectSolution,
  siteData,
  match,
  history,
  documentUploadUrl,
  postReportDetails,
  generateReport,
  getLocationApprovalPending,
  location,
  locationApproval,
  getPocBySiteId,
  pocListBySiteId,
  postSendReportMail,
  getCheckLocation,
  locationCheck,
  userProfile,
  inventoryData,
  getInventory,
  getMaterial,
  getMateriaById,
  postSolution,
  postGateInventory,
  getSiteData,
  siteDetails,
  calculateDistance,
  engDistanceData,
  getDistanceData,
  distanceDetails
}) => {
  const islatlng = useLatLng();
  const [modalFlag, setModalFlag] = useState(null);
  const [isModal, setIsModal] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [generateFlag, setGenerateFlag] = useState(false);
  const [mrfReportModal, setMrfReportModal] = useState(false);
  const [generateReportFlag, setGenerateReportFlag] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [poclist, setPocList] = useState([]);
  const [modal, setModal] = useState(false);
  const [showOtherEmail, setShowOtherEmail] = useState(false);
  const [checkMismatch, setCheckMismatch] = useState(1);
  const [mailList, setMailList] = useState([]);
  const [otherEmail, setOtherEmail] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState('');
  const [opened, setIsOpened] = useState(false);

  const { baseUrl } = useContext(BaseUrl);
  const [inventoryForm, setInventoryForm] = useState({
    site_id: "",
    gate_id: "",
    data: [],
  });
  const Headers = ['Category','Ops Quantity', 'Sales Quantity'];
  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, [])

  useEffect( () => {
    (async () => {
      await getDistanceData(match.params.id, 'site_inspection_material')
    })()
  }, [])

  useEffect( () => {
    setIsOpen(true)
    if(distanceDetails !== {} && Object.keys(distanceDetails).length > 0){
      if(!distanceDetails['total_hours']){
        setIsOpen(false);
      }
    }
  }, [distanceDetails])

  useEffect( () => {
    if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
      toast.success('Distance is successfully fetched');
      setIsOpen(false);
      Object.keys(engDistanceData).forEach(key => {
        delete engDistanceData[key];
      })
    }else if(engDistanceData === null){
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])


  useEffect(() => {
    if (getInventory !== null){
      (async () => await getInventory(''))();
    }
     
  }, [getInventory]);

  useEffect(() => {
    (() => {
      if (
        poclist &&
        poclist.length > 0 
      ) {
        setShowOtherEmail(true);
      } else {
        setShowOtherEmail(false);
      }
      // if (
      //   poclist &&
      //   Object.values(poclist.length) > 0 &&
      //   Object.values(poclist).some((obj) => obj.id === 'Others')
      // ) {
      //   setShowOtherEmail(true);
      // } else {
      //   setShowOtherEmail(false);
      // }
    })();
  }, [poclist]);

  useEffect(() => {
    if (
      getSiteInspectSolution !== null &&
      match.params.id &&
      getLocationApprovalPending !== null
    )
      (async () => {
        setIsLoading(true);
        await getSiteInspectSolution(match.params.id, match.params.stageId);
        if (match.params.gate === 'site-inspection') {
          await getLocationApprovalPending(
            match.params.id,
            islatlng?.lat,
            islatlng?.lng
          );
        } else {
          await getCheckLocation(match.params.id, islatlng?.lat, islatlng?.lng);
        }
        await getPocBySiteId(match.params.id);
        setIsLoading(false);
      })();
  }, [getSiteInspectSolution, getLocationApprovalPending, match.params.id, islatlng]);

  const handleModalHide = () => setModalFlag(null);
  const modalHide = () => setIsModal(null);
  const mrfReportModalHide = () => setMrfReportModal(false);
  const openHideModal = () => setOpenModal(false);
  const emailModalHide = () => setModal(false);
  const checkInventory = (val) => {
    setFlag(val);
    siteData &&
      siteData.gates &&
      siteData.gates.length > 0 &&
      siteData.gates.map((obj) => {
        obj.checklist_data.map((el) => {
          if (el.checklist_id === 8 && el.completed === null) {
            setModalFlag(true);
          }
          if (el.checklist_id === 8 && el.completed === 1) {
            setModalFlag(false);
          }
        });
      });
  };

  useEffect(() => {
    if (modalFlag === false && modalFlag !== null) {
      history.push({
        pathname: `/dashboard/material-requisition/${match.params.id}/stage/${match.params.stageId}`,
        state: { view: flag, status: location.state && location.state.status },
      });
    }
  }, [modalFlag]);

  const onClickViewMrf = (val) => {
    checkInventory(val);
  };



  useEffect(() => {
    if (
      Object.keys(siteData.report_data !== undefined && siteData.report_data)
        .length > 0
    ) {
      setGenerateReportFlag(true);
    } else if (
      Object.keys(siteData.report_data !== undefined && siteData.report_data)
        .length === 0
    ) {
      setGenerateReportFlag(false);
    }
  }, [siteData]);

 
  const finalSubmit = async (site_id) => {
    if(site_id){
      const data = {
        stage_id: match.params.stageId,
        site_id: match.params.id,
      };
      setIsLoading(true);
      const res = await postSolution(data);
      setIsLoading(false);
      if (res && res.checkMismatch ) {
        setIsModal(true);
        setCheckMismatch(res.checkMismatch);
      }
      // postSolution
    }
   
  }

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


  const callFor = (url, id, gateId) => {
    if (url.includes('inventory')) {
      history.push({
        pathname: `/dashboard/inventory/${match.params.id}/stage/${match.params.stageId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('siteInformationChecklist')) {
      history.push({
        pathname: `/dashboard/site-info/${match.params.id}/stage/${match.params.stageId}?gateId=${gateId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('civilChecklistQuestions')) {
      history.push({
        pathname: `/dashboard/civil-check/${match.params.id}/stage/${match.params.stageId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('hardware_installation_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/hardware-installation/${match.params.id}/stage/${match.params.stageId}`,
      });
    } else if (url.includes('handover_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/handover_checklist/${match.params.id}/stage/${match.params.stageId}`,
      });
    }
  };

  return (
    <Layout
      title={`Site Inspection Material Mapping`}
      status={location.state && location.state.status}
      isGoback
      isLoading={isLoading}
      linkFlag={true}
      linkUrl={`/dashboard/site-stage/${match.params.id}`}
    >

      {role === 9 && isOpen && opened ?
          <div className="popup-box">
            <div className="box">
              {siteDetails?.lead_id !== undefined &&
                  <Link
                      to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
                      className="btn btn-primary mb-4"
                      style={{'cursor': 'pointer','border':'0px','box-shadow':'none !important','position':'relative','top':'-17px',
                        'float':'right'}}
                  >
                    x
                  </Link>
              }
              <DistanceCalculator
                  siteData={siteDetails}
                  getSiteData={getSiteData}
                  calculateDistance={calculateDistance}
                  siteId={match.params.id}
                  moduleType={'site_inspection_material'}
                  to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
              />
            </div>
          </div> :
          <>
            {siteData && siteData.site_data &&
                <>
                  <div className="col-md-12 col-xs-12">
                    <h4>{siteData.site_data.client_name} ({siteData.site_data.site_no})</h4>
                  </div>
                  <div className="col-md-3"></div>
                </>
            }

            <FormSection title={'Requirement'}>
              <div className="details-listing">
                {siteData && siteData.categories &&
                    <>
                      <table style={{border: '1px solid', width: '100%'}}>
                        <tr style={{border: '1px solid', backgroundColor: '#2f80ed', color: '#fff'}}>
                          <th style={{border: '1px solid', padding: '6px'}}>Category</th>
                          <th style={{border: '1px solid', padding: '6px'}}>Ops Qty</th>
                          <th style={{border: '1px solid', padding: '6px'}}>Sales Qty</th>
                        </tr>

                        {siteData.categories.map((obj, index) => {
                          return (
                              <>
                                {obj.operation_quantity === obj.sale_quantity ?
                                    <tr key={index}>
                                      <td style={{border: '1px solid', padding: '6px'}}>{obj.category_name}</td>
                                      <td style={{border: '1px solid', padding: '6px'}}>{obj.operation_quantity}</td>
                                      <td style={{border: '1px solid', padding: '6px'}}>{obj.sale_quantity}</td>
                                    </tr>
                                    :
                                    <tr key={index} style={{"backgroundColor": "#ffe6e6"}}>
                                      <td style={{border: '1px solid', padding: '6px'}}>{obj.category_name}</td>
                                      <td style={{border: '1px solid', padding: '6px'}}>{obj.operation_quantity}</td>
                                      <td style={{border: '1px solid', padding: '6px'}}>{obj.sale_quantity}</td>
                                    </tr>
                                }


                              </>

                          );

                        })}
                      </table>
                      {/* <TableSection
              data={siteData.categories}
              headers={Headers}
            ></TableSection> */}
                    </>

                }
              </div>
            </FormSection>
            <hr/>
            {window.screen.width < 1000 ?
                <div className="col-md-12">
                  {siteData &&
                      match.params.gate !== 'handover-testing' &&
                      siteData.gates &&
                      siteData.gates.length > 0 &&
                      <Carousel
                          swipeable={true}
                          draggable={false}
                          showDots={true}
                          autoPlay={false}
                          autoPlaySpeed={100000}
                          responsive={responsive}
                          ssr={false} // means to render carousel on server-side.
                          keyBoardControl={false}
                          containerClass="carousel-container"
                          dotListClass="custom-dot-list-style"
                          // itemClass="carousel-item-padding-40-px"
                      >

                        {siteData.gates.map((obj, index) => {
                          return (
                              <div key={{index}}>
                                <CardSectionNew
                                    title={`Solution ` + obj.gate_no + ` - ` + obj.gate_name}
                                >

                                  {obj.checklist_data[1] &&
                                      <Button
                                          disabled={siteData.isFreez === 1 ? true : false}
                                          className={
                                            obj.checklist_data[1].completed === 1
                                                ? 'url-card card-success'
                                                :
                                                obj.is_material_update === 1 ? 'url-card card-success' :
                                                    'url-card card-danger'
                                          }
                                          onClick={() => {
                                            callFor(obj.checklist_data[1].url, obj.checklist_data[1].checklist_id, obj.gate_id);
                                          }}
                                      >
                                        Inventory Check
                                        {(obj.checklist_data[1].completed === 1) ?
                                            ` With Mat.`
                                            :
                                            obj.is_material_update === 1 ?
                                                ` No Mat.`
                                                :
                                                ``
                                        }
                                      </Button>
                                  }

                                  {/* <ProductInventory
                          title = {`Solution `+obj.gate_no}
                          data={inventoryData}
                          getMaterial={getMaterial}
                          getMateriaById={getMateriaById}
                          handleValue={handleProductData}
                        /> */}
                                </CardSectionNew>
                              </div>
                          );
                        })}

                      </Carousel>
                  }
                </div>
                :
                <div className="col-md-12">
                  {siteData &&
                      match.params.gate !== 'handover-testing' &&
                      siteData.gates &&
                      siteData.gates.length > 0 &&
                      <>
                        {siteData.gates.map((obj, index) => {
                          return (
                              <div key={{index}}>
                                <CardSectionNew
                                    title={`Solution ` + obj.gate_no + ` - ` + obj.gate_name}
                                >

                                  {obj.checklist_data[1] &&
                                      <Button
                                          disabled={siteData.isFreez === 1 ? true : false}
                                          className={
                                            obj.checklist_data[1].completed === 1
                                                ? 'url-card card-success'
                                                :
                                                obj.is_material_update === 1 ? 'url-card card-success' :
                                                    'url-card card-danger'
                                          }
                                          onClick={() => {
                                            callFor(obj.checklist_data[1].url, obj.checklist_data[1].checklist_id, obj.gate_id);
                                          }}
                                      >
                                        Inventory Check
                                        {(obj.checklist_data[1].completed === 1) ?
                                            ` With Mat.`
                                            :
                                            obj.is_material_update === 1 ?
                                                ` No Mat.`
                                                :
                                                ``
                                        }
                                      </Button>
                                  }

                                  {/* <ProductInventory
                            title = {`Solution `+obj.gate_no}
                            data={inventoryData}
                            getMaterial={getMaterial}
                            getMateriaById={getMateriaById}
                            handleValue={handleProductData}
                          /> */}
                                </CardSectionNew>
                              </div>
                          );
                        })}
                      </>


                  }
                </div>
            }
            <hr/>
            {siteData && siteData.checkCount && siteData.gateCount && (siteData.checkCount === siteData.gateCount) ?
                <>
                  {siteData.isFreez === 1 ?
                      <div className='col-md-12 text-center'>
                        <small style={{"color": "red"}}>You can't change any value</small><br/>
                        <Button
                            className={`mb-4`}
                            disabled={true}
                        >
                          Final Submit
                        </Button>

                      </div>
                      :
                      <div className='col-md-12 text-center'>
                        <Button
                            className={`mb-4`}
                            onClick={() => {
                              finalSubmit(match.params.id)
                            }}
                        >
                          Final Submit
                        </Button>

                      </div>
                  }
                </>
                :
                <div className='col-md-12 text-center'>
                  <small style={{"color": "red"}}>Please submit all solution's inventory</small>
                  <Button
                      disabled={true}
                      className={`mb-4`}
                  >
                    Final Submit

                  </Button>

                </div>
            }


            {/* </div> */}
            <ModalPop
                title={`Final Submitted`}
                show={isModal}
                handleModalHide={handleModalHide}
                keyboard
                backdrop
            >
              <div className="text-center">
                <div className="success">
                  <img src={Images?.tick} alt=""/>
                </div>
                {(checkMismatch === 1) ?
                    <>
                      <h5>{localization.preB2bSuccess}</h5>
                      <Link
                          to={`${baseUrl}/gate/site-inspection/${match.params.id}/stage/1`}
                          className="btn btn-primary mb-4"
                      >
                        {localization.viewSiteInformation}{" "}
                        <img src={Images?.ArrowRight} alt=""/>
                      </Link>
                    </>
                    :
                    <>
                      <h5>Mismatch in Data Going for approval!</h5>
                      <Button
                          onClick={() => window.location.reload(false)}
                          className="btn btn-primary mb-4"
                      >
                        {localization.viewSiteInformation}{" "}
                        <img src={Images?.ArrowRight} alt=""/>
                      </Button>
                    </>

                }


              </div>
            </ModalPop>

          </>
      }
    </Layout>
  );
};
export default SiteInspectionMaterial;
